import { useFischer } from './fischerPlugin';

// Composable version for use in Vue components
export const useAssetUrl = () => {
  const fischer = useFischer();

  const getAssetUrl = (asset: string) =>
    IS_SHOWROOM ? asset : `${fischer.hostUrlBase()}/dist/fischer-website-rebrush/${asset}`;

  return { getAssetUrl };
};

// Standalone helper for use in utility files (requires fischer instance)
export const createGetAssetUrl = (hostUrlBase: string) => {
  return (asset: string) =>
    IS_SHOWROOM ? asset : `${hostUrlBase}/dist/fischer-website-rebrush/${asset}`;
};
